<template>
    <div class="winter-index">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <!-- 头部banner -->
            <div class="top-bg">
                <img src="./img/icon_img_04.png"
                     class="back"
                     @click="clickBack"
                     alt="">
                <img src="./img/index-bg.jpg"
                     class="index-bg"
                     alt="">
                <div class="right-btn">
                    <span class="btn"
                          @click="activeRule"><span>活动规则</span></span>
                    <span class="btn"
                          @click="invitationStu"><span>邀请学生</span></span>
                </div>
            </div>
            <!-- 作业列表 -->
            <div class="task-list">
                <div class="task-item"
                     v-if="mathData.length">
                    <span class="subject-title">数学-寒假作业</span>
                    <div class="unit-class-list"
                         v-for="(item,index) in mathData"
                         :key="index">
                        <div class="unit-class-item">
                            <span class="unit-name">{{item.unit_name}}</span>
                            <span class="preview"
                                  @click="previewTask(item,21)">预览</span>
                            <span class="btn share"
                                  @click="share(item,21)">分享给学生</span>
                            <span class="btn view-done"
                                  @click="viewDetail(item,21)">查看完成情况</span>
                        </div>
                    </div>
                </div>
                <div class="task-item"
                     v-if="chineseData.length">
                    <span class="subject-title">语文-寒假作业</span>
                    <div class="unit-class-list"
                         v-for="(item,index) in chineseData"
                         :key="index">
                        <div class="unit-class-item">
                            <span class="unit-name">{{item.unit_name}}</span>
                            <span class="preview"
                                  @click="previewTask(item,51)">预览</span>
                            <span class="btn share"
                                  @click="share(item,51)">分享给学生</span>
                            <span class="btn view-done"
                                  @click="viewDetail(item,51)">查看完成情况</span>
                        </div>
                    </div>
                </div>
                <div class="task-item"
                     v-if="sfData.length">
                    <span class="subject-title">书法-寒假作业</span>
                    <div class="unit-class-list"
                         v-for="(item,index) in sfData"
                         :key="index">
                        <div class="unit-class-item">
                            <span class="unit-name">{{item.unit_name}}</span>
                            <span class="btn share"
                                  @click="share(item,11)">分享给学生</span>
                            <span class="btn view-done"
                                  @click="viewDetail(item,11)">查看完成情况</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 赢取好礼 -->
            <div class="winner"
                 v-if="mathData.length||chineseData.length">
                <div class="user-info">
                    <div class="my-integral">
                        <span class="avatar">
                            <img src="https://cdn.m.tbkt.cn/tea_default.png"
                                 alt="">
                        </span>
                        <div class="text">
                            <strong>我的积分 <span>{{power}}</span></strong>
                            <p>学生做作业，老师得积分</p>
                        </div>
                    </div>
                    <span class="detail-integral"
                          @click="integralDetail">积分明细</span>
                </div>
                <div class="award-list">
                    <div class="award-item"
                         v-for="(item,index) in level_info"
                         :key="index">
                        <div class="gold">
                            <img :src="item.price==20?require('./img/gold20.png'):item.price==30?require('./img/gold30.png'):item.price==50?require('./img/gold50.png'):''"
                                 class="gold-img">
                            <img :src="item.is_win==1?require('./img/winner.png'):require('./img/no-winner.png')"
                                 v-if="item.status==1"
                                 class="winner-img">
                        </div>
                        <!--status: 0, //未抽奖   1已抽奖-->
                        <!--click_status: 0,//不可抽奖   1可以抽奖-->
                        <!--is_win:0  //未中奖   1已中奖 -->
                        <div class="text">
                            <strong>获得{{item.level*100}}积分</strong>
                            <p>即可立即抽奖</p>
                            <p>当前{{item.num}}人已抽奖</p>
                            <span class="btn "
                                  :class="item.click_status==1&&item.status==0?'hav-lucky':''"
                                  @click="handleAward(item)">
                                {{item.status==1?'已抽奖':item.click_status == 1 ? "立即抽奖" : "未达标准"}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 活动规则弹窗 -->
            <div class="active-rule-bg"
                 v-if="showRule">
                <div class="rule-content">
                    <img src="./img/icon-rule-close.png"
                         class="close-btn"
                         @click="closeRule"
                         alt="">
                    <p><strong>1</strong>活动时间：<span>2026年2月01日00:00:00至 2026年2月28日12:00:00</span></p>
                    <p><strong>2</strong>本活动短信邀请次数计入当月发作业次数。</p>
                    <p><strong>3</strong>活动数据更新可能会有延迟。</p>
                    <p><strong>4</strong>在参与活动过程中，如用户出现违规行为， 平台有权取消其获奖资格。</p>
                </div>
            </div>
            <!-- 抽奖结果页 -->
            <div class="award-result-bg"
                 v-if="awardResult">
                <div class="award-result">
                    <template v-if="awardResult==1">
                        <img src="./img/award-bg2.png"
                             class="result-pic"
                             alt="">
                        <p class="result-txt">金币与您擦肩而过</p>

                    </template>
                    <template v-if="awardResult==2">
                        <img src="./img/award-bg1.png"
                             class="result-pic"
                             alt="">
                        <p class="result-txt">抽中{{goldNum}}金币</p>
                        <img :src="goldImg"
                             class="gold-num"
                             alt="">
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
document.title = "寒假作业";
import loadings from "COMPONENTS/base/loadingS.vue";
export default {
    components: {
        loadings,
    },
    data () {
        return {
            loading: false,
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            //活动规则弹窗
            showRule: false,
            //抽奖结果页 0:关闭结果页  1：未中奖   2：中奖
            awardResult: 0, //
            //数学寒假作业
            mathData: [],
            //语文寒假作业
            chineseData: [],
            //书法寒假作业
            sfData: [],
            //教师积分
            power: '',
            //教师积分列表
            level_info: [],
            //抽中的金币数量
            goldNum: null,
            //带有金币的奖品图
            goldImg: '',
        }
    },
    created () {
        //修改页面标题
        document.title = "寒假作业";
        this.activityIndexData()
    },
    methods: {
        //获取教师积分信息
        activityIndexData () {
            let url = API_URL_HD_API + '/winter2023/tea/index/'
            let params = {}
            this.$http.post(url, params).then(res => {
                if (res.data.response === 'ok') {
                    //数学作业数据
                    this.mathData = res.data.data.sx_class
                    //语文作业数据
                    this.chineseData = res.data.data.yw_class
                    //书法作业数据
                    this.sfData = res.data.data.sf_class
                    //教师积分数据
                    this.power = res.data.data.power
                    //教师积分列表
                    this.level_info = res.data.data.level_info
                }
            })
        },
        //左上角返回
        clickBack () {
            if (this.inApp) {
                this.appFunction("ys_finish");
            } else {
                this.$router.go(-1)
            }

        },
        //活动规则
        activeRule () {
            this.showRule = true
        },
        //邀请学生
        invitationStu () {
            this.$router.push('/activity/2024winter/timing')
        },
        //预览作业
        previewTask (item, sid) {
            this.$router.push(`/activity/2024winter/preview/${sid}/${item.unit_class_id}?unit_name=${encodeURIComponent(item.unit_name)}`)
        },
        //分享给学生
        share (item, sid) {
            let that = this
            if (this.inApp) {
                let title = item.school_name + (sid == 21 ? "数学" : sid == 51 ? "语文" : "书法") + "寒假作业";
                let content = "点击参加" + (sid == 21 ? "数学" : sid == 51 ? "语文" : "书法") + "寒假作业";
                this.appFunction("ys_share", `${title},${content},${item.wap_url},${String(sid)[0]},${item.unit_class_id},0,26,寒假作业活动分享`);

            } else {
                /**获取分享短链地址 */
                this.$http.post(API_URL_SORT_API + '/create_sort/', {
                    url: item.wap_url,
                    sort_type: 1
                }).then((res) => {
                    if (res.data.response === 'ok') {
                        let content = item.school_name + (sid == 21 ? "数学" : sid == 51 ? "语文" : "书法") + "寒假作业,点击链接参加寒假作业，链接：" + res.data.data.short_url;
                        layer.alert('在输入框中进行粘贴后，点击发送即可！', 'tea', function (index) {
                            that.copyText(content)
                            layer.close(index)
                        }, '分享链接复制成功')
                    }
                })

            }

        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        //查看完成情况
        viewDetail (item, sid) {
            if (sid === 11) {
                this.$router.push(`/activity/2024winter/sf_detail/${item.unit_class_id}`)

            } else {
                this.$store.commit('set2022WinterTabtype', 1)
                this.$router.push(`/activity/2024winter/viewDetail/${sid}/${item.unit_class_id}`)
            }
        },
        //查看积分明细
        integralDetail () {
            this.$router.push('/activity/2024winter/pointsdetail')
        },
        //立即抽奖
        handleAward (e) {
            if (e.status != 0 || e.click_status != 1) {
                return
            }
            layer.open({ type: 2, shadeClose: false, });
            let url = API_URL_HD_API + '/winter2023/tea/lottery/'
            let params = {
                level: e.level
            }
            this.$http.post(url, params).then(res => {
                layer.closeAll();
                if (res.data.response === 'ok') {
                    if (res.data.data.lottery_count) {
                        this.awardResult = 2;
                        this.goldNum = res.data.data.lottery_count;
                        this.goldImg = e.level == 1 ? require('./img/icon-gold20.png') : e.level == 2 ? require('./img/icon-gold30.png') : require('./img/icon-gold50.png')
                    } else {
                        this.awardResult = 1;
                    }
                    let timer = setTimeout(() => {
                        //需要定时执行的代码
                        this.awardResult = null
                        this.activityIndexData()
                        clearTimeout(timer);
                    }, 2000)
                }
            })
        },
        //关闭规则弹窗
        closeRule () {
            this.showRule = false
        },
    }
}
</script>

<style lang="scss" scoped>
//页面背景
.winter-index {
    background-color: #dc2b17;
    padding-bottom: 100px / $ppr;
    min-height: 737px;
    max-width: 720px / $ppr;
}
// 头部banner
.top-bg {
    position: relative;
    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 27px / $ppr;
        height: 42px / $ppr;
        padding: 53px / $ppr 23px / $ppr;
    }
    .index-bg {
        width: 100%;
    }
    .right-btn {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-40%);
        .btn {
            display: block;
            width: 80px / $ppr;
            height: 120px / $ppr;
            margin-top: 20px / $ppr;
            background: url("./img/btn-bg2.png") no-repeat;
            background-size: 100% 100%;
            font-size: 26px / $ppr;
            color: #f21500;
            border-radius: 20px / $ppr 0 0 20px / $ppr;
            text-align: center;
            padding: 23px / $ppr 7px / $ppr 23px / $ppr 18px / $ppr;
            box-sizing: border-box;
            font-weight: bold;
            position: relative;
            line-height: 1.5;

            span {
                position: relative;
            }
        }
    }
}
//作业列表
.task-list {
    margin-top: -115px / $ppr;
    position: relative;
    .task-item {
        text-align: center;
        .subject-title {
            display: inline-block;
            background: url("./img/task-bg.png") no-repeat;
            background-size: 100% 100%;
            font-size: 32px / $ppr;
            color: #fff0e0;
            padding: 9px / $ppr 73px / $ppr;
            font-weight: bold;
            margin-bottom: 26px / $ppr;
            margin-top: 36px / $ppr;
        }
        .unit-class-list {
            padding: 0 24px / $ppr;
            margin-bottom: 24px / $ppr;
            .unit-class-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: url("./img/class-bg.png") no-repeat;
                background-size: 100% 100%;
                padding: 42px / $ppr 24px / $ppr 42px / $ppr 40px / $ppr;
                font-size: 28px / $ppr;
                margin-bottom: 24px / $ppr;
                .unit-name {
                    color: #333;
                    font-weight: bold;
                    flex: 1;
                    text-align: left;
                }
                .preview {
                    color: #5e89ef;
                }
                .btn {
                    display: inline-block;
                    padding: 16px / $ppr 18px / $ppr;
                    border-radius: 56px / $ppr;
                    color: #fff;
                    font-size: 24px / $ppr;
                    line-height: 1;
                    margin-left: 20px / $ppr;
                }
                .share {
                    background: #11ca8e;
                    margin-left: 36px / $ppr;
                }
                .view-done {
                    background: #ef440d;
                }
            }
        }
    }
}
//赢取好礼
.winner {
    margin: 60px / $ppr 24px / $ppr 0;
    padding: 155px / $ppr 37px / $ppr 0 37px / $ppr;
    background: url("./img/gift-bg.png") no-repeat;
    background-size: 100%;
    position: relative;
    .user-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .my-integral {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .avatar {
                width: 90px / $ppr;
                height: 90px / $ppr;
                border-radius: 100%;
                margin-right: 20px / $ppr;
                overflow: hidden;
            }
            .text {
                strong {
                    font-size: 30px / $ppr;
                    color: #141414;
                    font-weight: bold;
                    span {
                        color: #f21500;
                        font-size: 44px / $ppr;
                    }
                }
                p {
                    font-size: 24px / $ppr;
                    color: #ab7648;
                }
            }
        }
        .detail-integral {
            font-size: 24px / $ppr;
            color: #5e89ef;
            padding-bottom: 5px / $ppr;
            border-bottom: 1px solid #5e89ef;
        }
    }
    .award-list {
        padding: 48px / $ppr 0;
        .award-item {
            background: #fff;
            border-radius: 15px / $ppr;
            padding: 40px / $ppr 48px / $ppr;
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px / $ppr;
            .gold {
                position: relative;
                .gold-img {
                    width: 232px / $ppr;
                    height: 232px / $ppr;
                }
                .winner-img {
                    position: absolute;
                    right: 16px / $ppr;
                    top: 16px / $ppr;
                    width: 97px / $ppr;
                    height: 97px / $ppr;
                }
            }
            .text {
                padding-top: 14px / $ppr;
                padding-right: 26px / $ppr;
                strong {
                    display: block;
                    color: #870803;
                    font-weight: bold;
                    font-size: 30px / $ppr;
                    margin-bottom: 15px / $ppr;
                    line-height: 1;
                }
                p {
                    color: #999999;
                    font-size: 24px / $ppr;
                    margin-bottom: 5px / $ppr;
                }
                .btn {
                    display: block;
                    width: 180px / $ppr;
                    line-height: 64px / $ppr;
                    font-size: 30px / $ppr;
                    background: #bbbbbb;
                    color: #fff;
                    text-align: center;
                    border-radius: 64px / $ppr;
                    margin-top: 30px / $ppr;
                }
                .hav-lucky {
                    background: #ef440d;
                }
            }
        }
    }
}
//活动规则弹窗
.active-rule-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    .rule-content {
        box-sizing: border-box;
        width: 672px / $ppr;
        padding: 175px / $ppr 35px / $ppr 50px / $ppr 45px / $ppr;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: url("./img/active-rule-bg.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .close-btn {
            width: 47px / $ppr;
            height: 47px / $ppr;
            position: absolute;
            top: -10px / $ppr;
            right: 0;
        }
        p {
            font-size: 26px / $ppr;
            color: #333;
            line-height: 1.7;
            padding-left: 60px / $ppr;
            position: relative;
            margin-bottom: 35px / $ppr;
            strong {
                position: absolute;
                left: 0;
                top: 4px / $ppr;
                display: inline-block;
                width: 40px / $ppr;
                height: 40px / $ppr;
                line-height: 44px / $ppr;
                font-size: 30px / $ppr;
                color: #ffeccf;
                text-align: center;
                border-radius: 40px / $ppr;
                background: #dc2b17;
                font-weight: bold;
            }
            span {
                color: #dc2b17;
                font-weight: bold;
            }
        }
    }
}
//抽奖结果页
.award-result-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    .award-result {
        width: 552px / $ppr;
        height: 826px / $ppr;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .result-txt {
            width: 100%;
            text-align: center;
            font-size: 24px / $ppr;
            color: #b43413;
            position: absolute;
            top: 41%;
        }
        .gold-num {
            width: 205px / $ppr;
            height: 175px / $ppr;
            position: absolute;
            left: 50%;
            top: 65%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>